export default {"src":"/_next/static/media/checkmark-icon-3.16d9b98d.svg","height":24,"width":26,"blurWidth":0,"blurHeight":0};